import { Carousel, carouselItem } from "element-ui";
const element = {
  install: function(Vue) {
    Vue.use(Carousel);
    Vue.use(carouselItem);
  }
};
export default element;
